import React from 'react';
import '../../components/css/popupstyle.css';
import DeleteIcon from '../.././components/css/dark/img/delete.svg';
import EditIcon from '../.././components/css/dark/img/edit2.svg';
import { userService } from '../../_services';
import $ from 'jquery';
import { debuglog } from 'util';

class ManageProfile extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: '',
            userdata: JSON.parse(localStorage.getItem('user')),
            loader: false,
            commissionMilestone: [],
            UserList: [],
            btnLoader: false,
            IsCustomGroup: false,
            isEditable: false,
            IsPrescribeData: false,
            IsCommissionPrescribeData: false
        }
        this.handleChangeChk = this.handleChangeChk.bind(this);
        this.handleChangeUnChk = this.handleChangeUnChk.bind(this);
        this.handlePrescribeData = this.handlePrescribeData.bind(this);
        this.handleCommissionPrescribeData = this.handleCommissionPrescribeData.bind(this);
    }

    componentDidMount() {
        this.fetchData(this.state.userdata.paramsname, this.state.userdata.userrole, this.props.wholesalerId);
        setTimeout(function () {
            $(".checked").prop("checked", true);
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 600);
    }
    addMilestone = () => {
        let rowCount = $('#milestoneTable tr').length;
        let milestone = this.state.commissionMilestone;
        if (milestone == null || milestone == 0) {
            var firstMilestone = []
            let newMilestone = {
                msid: rowCount + 1,
                from: '',
                to: '',
                commission: '',
                isineditedmode: true
            };
            firstMilestone.push(newMilestone);
            this.setState({ milestoneCreated: true, commissionMilestone: firstMilestone, error: '' });
        } else {
            let newMilestone = {
                msid: rowCount,
                from: '',
                to: '',
                commission: '',
                isineditedmode: true
            };
            milestone.push(newMilestone);
            this.setState({ milestoneCreated: true, commissionMilestone: milestone, error: '' });
        }
    }
    handleChangeChk = (e) => {
        e.stopPropagation();
        this.setState({ IsCustomGroup: true });
    }
    handleChangeUnChk = (e) => {
        e.stopPropagation();
        this.setState({ IsCustomGroup: false });
    }
    hideCommission = () => {
        let x = this.state.UserList;

        x.forEach(function (item) {
            item.isRuleBased = false;
        });
        this.setState({ UserList: x });
    }
    showCommission = () => {

        let x = this.state.UserList;

        x.forEach(function (item) {
            item.isRuleBased = true;
        });
        this.setState({ UserList: x });
    }
    handlePrescribeData = (e) => {
        e.stopPropagation();
        this.setState({ IsPrescribeData: e.currentTarget.value = 'yes' ? true : false });
    }
    handleCommissionPrescribeData = (openOverride) => {
        this.setState({ IsCommissionPrescribeData: openOverride });
        if (openOverride) {
            let whEmail = $('input[name="email"]').val();
            this.props.closeEditProfilePopup(this.props.wholesaler_name, this.props.wholesalerId, this.props.whPrefix, this.props.activePagin, this.props.whSearch, whEmail);
            this.props.openAddOverridePopup(this.props.wholesaler_name, this.props.wholesalerId, this.props.whPrefix, this.props.activePagin, this.props.whSearch, whEmail, this.props.wholesalerId);
        }
    }
    fetchData(roleName, roleType, id) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ roleName, roleType, id })
            };
            return fetch(`/api/admin/GetNewWhDetail`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        let tierJson;
                        let global = this.state;
                        if (this.props.isDynamic) {
                            apidata.forEach(function (item) {
                                // eslint-disable-next-line no-unused-expressions
                                item.isDynamic = true,
                                    tierJson = item.tierJson
                            });
                        } else {
                            apidata.forEach(function (item) {
                                tierJson = item.tierJson;
                            });
                        }
                        if (tierJson != '') {
                            apidata.forEach(function (item) {
                                item.tierJson = JSON.parse(item.tierJson);
                            });
                        }
                        if (this.state.UserList.length > 0) {
                            this.setState({ UserList: apidata, commissionMilestone: JSON.parse(apidata[0].msJson), IsCustomGroup: apidata[0].isCustomGroup, isEditable: apidata[0].isDynamic });
                        }
                        else {
                            this.setState({ UserList: apidata, commissionMilestone: JSON.parse(apidata[0].msJson), isEditable: apidata[0].isDynamic });
                        }
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    handleEdit = (e) => {

        // current index
        let currentIndex = e.target.getAttribute('dataindex');

        let milestone = JSON.parse(JSON.stringify(this.state.commissionMilestone));

        milestone[currentIndex].isineditedmode = true;
        this.setState({ commissionMilestone: milestone });
    }
    saveData = (e) => {
        // get input field values
        let currentIndex = e.target.getAttribute('dataindex');
        let htmlprefix = $(e.target).parents('.milestoneData');
        let milestoneIndex = htmlprefix.find('.first-one').text();
        let from = htmlprefix.find('input[name = "from"]').val();
        let to = htmlprefix.find('input[name = "to"]').val();
        let commission = htmlprefix.find('input[name = "mComm"]').val();
        let wholeNumber = /^(?:0|(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*)))$/;
        let milestone = this.state.commissionMilestone;

        if (!userService.Check_Null_Empty(from) && !userService.Check_Null_Empty(to) && !userService.Check_Null_Empty(commission) && userService.validateCurrency(commission)) {
            // validate all fields
            if (wholeNumber.test(from)) {
                if (wholeNumber.test(to)) {
                    if (commission > 10) {
                        this.setState({ error: 'Commission should not be more than 10' });
                        return false;
                    } else {
                        // to field value is greater than from
                        if (parseInt(to) > parseInt(from)) {
                            milestone[currentIndex].msid = milestoneIndex;
                            milestone[currentIndex].from = from;
                            milestone[currentIndex].to = to;
                            milestone[currentIndex].commission = commission;
                            milestone[currentIndex].isineditedmode = false;
                            this.setState({ commissionMilestone: milestone, error: '' });
                        } else {
                            this.setState({ error: 'The milestone To fields should be greater than the From fields' });
                            return false;
                        }
                    }
                } else {
                    this.setState({ error: 'Invalid to value' });
                    return false;
                }
            } else {
                this.setState({ error: 'Invalid from value' });
                return false;
            }
        }
        else {
            this.setState({ error: 'All fields are required and commission should be a numeric value e.g. 0.5 or 1.5' });
            return false;
        }
        return true;
    }
    handleSaveSubmit = (e) => {
        // disable submit
        this.setState({ loader: false, btnLoader: true });
        $(e.target).attr("disabled", true);

        // get input field values
        let htmlprefix = $(e.target).parents('.wholesaler-section');
        let whid = this.props.wholesalerId;
        let roleName = this.state.userdata.paramsname;
        let roleType = this.state.userdata.userrole;
        let whname = this.props.wholesaler_name;
        let companyId = e.target.getAttribute('datacompanyid');
        let whemail = htmlprefix.find('input[name = "email"]').val();
        let whcontact = htmlprefix.find('input[name = "contactName"]').val();
        let whcomm = htmlprefix.find('input[name = "wholesalerCommission"]').val();
        let isruled = false;
        if (this.state.UserList.length > 0) {
            isruled = this.state.UserList[0].isRuleBased;
        }
        else {
            if (htmlprefix.find('input[name = "rules"]:checked').val() == 'yes') {
                isruled = true;
            } else {
                isruled = false;
            }
        }
        let isdashboardneeded = false;
        let iscustomgroup = false;
        let dynamicUser = false;
        let isprescribeData = false;
        let isTriprx = $('#triprx').prop('checked');
        if (this.state.UserList.length > 0) {
            iscustomgroup = this.state.IsCustomGroup;
        }
        else {
            iscustomgroup = this.state.IsCustomGroup;
            if (htmlprefix.find('input[name = "customGroup"]:checked').val() == 'yes') {
                iscustomgroup = true;
            } else {
                iscustomgroup = false;
            }
        }
        if (htmlprefix.find('input[name = "prescriberData"]:checked').val() == 'yes') {
            isprescribeData = true;
        } else {
            isprescribeData = false;
        }
        if (htmlprefix.find('input[name = "dynamicCommission"]:checked').val() == 'yes') {
            dynamicUser = true;
        } else {
            dynamicUser = false;
        }
        let isGlicEnable = $('#enableGlic').prop('checked');
        let gnprefix = this.props.whPrefix;
        let msjson;
        if (isruled == true) {
            msjson = this.state.commissionMilestone;
        } else {
            msjson = "";
        }
        if (!userService.Check_Null_Empty(whcomm) && userService.validateCurrency(whcomm)) {
            if (whcomm > 10) {
                this.setState({ error: 'Commission should not be more than 10', loader: false, btnLoader: false });
                $(e.target).attr("disabled", false);
            } else {

                let IsError = 0;
                let milestoneOpen = false;

                if (msjson == null || parseInt(msjson.length) == 0 || msjson == "") {
                    if (isruled == true) {
                        this.setState({ error: 'Add at least two milestones', loader: false, btnLoader: false });
                        $(e.target).attr("disabled", false);
                    } else {
                        this.addNewWholesaler(whid, roleName, roleType, whname, whemail, whcontact, whcomm, isruled, isTriprx, isprescribeData, isGlicEnable, isdashboardneeded, iscustomgroup, gnprefix, msjson, companyId, dynamicUser);
                    }

                } else {
                    let jsonLength = parseInt(msjson.length) - 1;
                    for (let i = 0; i < msjson.length; i++) {
                        if (msjson[i].isineditedmode == true) {
                            this.setState({ error: 'Save all milestones', loader: false, btnLoader: false });
                            $(e.target).attr("disabled", false);
                            milestoneOpen = true;
                        }
                    }

                    if (milestoneOpen == false) {

                        // sort our milestone using from values
                        msjson.sort(function (a, b) { return a.from - b.from });

                        // milestone must start from zero
                        if (parseInt(msjson[0].from) == 0) {

                            // from field value is equal to prev to field
                            for (let i = 0; i < msjson.length; i++) {
                                if (parseInt(msjson.length) == 1) {

                                    // msjon length 1 show error
                                    IsError = 1;

                                } else {

                                    if (i == parseInt(msjson.length) - 1) {
                                        break;
                                    } else {

                                        // from field value is equal to prev to field
                                        if (parseInt(msjson[i + 1].from) == msjson[i].to) {

                                            if (parseInt(msjson[jsonLength].to) == 999999) {
                                                continue;
                                            } else {
                                                IsError = 2;
                                            }

                                        } else {
                                            IsError = 3;
                                        }
                                    }
                                }
                            }
                            if (IsError == 0) {
                                this.addNewWholesaler(whid, roleName, roleType, whname, whemail, whcontact, whcomm, isruled, isTriprx, isprescribeData, isGlicEnable, isdashboardneeded, iscustomgroup, gnprefix, msjson, companyId, dynamicUser);
                            } else if (IsError == 1) {

                                this.setState({ error: 'Add at least two milestones', loader: false, btnLoader: false });
                                $(e.target).attr("disabled", false);

                            } else if (IsError == 2) {

                                this.setState({ error: 'The last milestone To field should be 999999', loader: false, btnLoader: false });
                                $(e.target).attr("disabled", false);
                            } else if (IsError == 3) {

                                this.setState({ error: 'The From field should equal the previous To field in each milestone (not including the first)', loader: false, btnLoader: false });
                                $(e.target).attr("disabled", false);
                            }
                        } else {
                            this.setState({ error: 'The lowest value for the From field must be 0', loader: false, btnLoader: false });
                            $(e.target).attr("disabled", false);
                        }
                    }
                }
            }
        } else {
            this.setState({ error: 'All fields are required and commission should be a numeric value e.g. 0.5 or 1.5', loader: false, btnLoader: false });
            $(e.target).attr("disabled", false);
        }
    }
    addNewWholesaler(whid, roleName, roleType, whname, whemail, whcontact, whcomm, isruled, isTriprx, isprescribeData, isGlicEnable, isdashboardneeded, iscustomgroup, gnprefix, msjson, companyid, isDynamic) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'MSJsonHeader': JSON.stringify(msjson) },
                body: JSON.stringify({ whid, roleName, roleType, whname, whemail, whcontact, whcomm, isruled, isGlicEnable, isdashboardneeded, iscustomgroup, gnprefix, companyid, isDynamic, isTriprx, isprescribeData })
            };
            return fetch(`/api/admin/AddNewWhDetail`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata[0].code == "1") {
                            this.setState({ loader: false, error: apidata[0].statusMessage });
                            setTimeout(() => {
                                this.handleCancel();
                            }, 2500);
                        } else {
                            this.setState({ error: apidata[0].statusMessage, loader: false, btnLoader: false });
                            $('.save').attr("disabled", false);
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Error', loader: false, btnLoader: false });
                        $('.save').attr("disabled", false);
                    }
                });
        }
        catch (error) {
        }
    }
    handleCancel = () => {
        this.props.closeEditProfilePopup();
        this.props.openWholesalerPopup(this.props.activePagin, this.props.whSearch);
    }
    cancelList = (e) => {
        let x = this.state.commissionMilestone;
        let indexedvalue = x[e.target.getAttribute('dataindex')];

        if (this.validation(indexedvalue.from, indexedvalue.to, indexedvalue.commission)) {
            x.every(function (a, index) {
                if (index == parseInt(e.target.getAttribute('dataindex'))) {
                    a.isineditedmode = false;
                    return false;
                } else {
                    return true;
                }
            });
            this.setState({ commissionMilestone: x, error: '' });
        } else {
            x.splice(e.target.getAttribute('dataindex'), 1);
            this.setState({ commissionMilestone: x, error: '' });
        }
    }
    validation(from, to, commission) {
        if (!userService.Check_Null_Empty(from) && !userService.Check_Null_Empty(to) && !userService.Check_Null_Empty(commission) && userService.validateCurrency(commission)) {
            return true;
        } else {
            return false;
        }
    }
    deleteMilestone = (e) => {
        let currentIndex = e.target.getAttribute('dataindex');
        let x = this.state.commissionMilestone;
        x.splice(currentIndex, 1);
        this.setState({ commissionMilestone: x, error: '' });
    }
    addOverrides = () => {
        let whEmail = $('input[name="email"]').val();
        this.props.closeEditProfilePopup();
        this.props.openOverridePopup(this.props.wholesaler_name, this.props.wholesalerId, this.props.whPrefix, this.props.activePagin, this.props.whSearch, whEmail);
    }
    advanceSetting = (e) => {
        let whEmail = $('input[name="email"]').val();
        let isGlic = $(e.target).attr('data-glic');
        this.props.closeEditProfilePopup();
        this.props.openSettingPopup(this.props.wholesaler_name, this.props.wholesalerId, this.props.whPrefix, this.props.activePagin, this.props.whSearch, whEmail, isGlic);
    }
    handleBonus = (e) => {
        this.props.closeEditProfilePopup();
        this.props.closeDatePopup(this.props.wholesaler_name, this.props.wholesalerId, this.props.whPrefix, this.props.activePagin, this.props.whSearch, '');
    }
    hideDynamicCommission = () => {
        try {
            let x = this.state.UserList;
            x.forEach(function (item) {
                item.isDynamic = false;
            });
            this.setState({ UserList: x });
        } catch (error) { }
    }
    showDynamicCommission = () => {
        try {
            let x = this.state.UserList;
            x.forEach(function (item) {
                item.isDynamic = true;
            });
            this.setState({ UserList: x });
        } catch (error) { }
    }
    dynamicCommission = (e) => {
        this.props.closeEditProfilePopup();
        this.props.dynamicCommission(this.props.wholesaler_name, this.props.wholesalerId, this.props.whPrefix, this.props.activePagin, this.props.whSearch, '', '', this.state.UserList);
    }
    render() {
        const { loader, error } = this.state;
        return (
            <div className='popup mfp-zoom-in override-content admin-popup profile'>
                <div className='popup_inner manage-distributor-design'>
                    {loader &&
                        <div className="theme-loader profile-loader"></div>
                    }

                    <h1>{this.props.wholesaler_name}<button onClick={this.handleCancel}>X</button></h1>
                    {
                        this.state.UserList.length > 0 ?
                            <div className="wholesaler-section">
                                {
                                    this.state.UserList.map((item, index) => {
                                        return (
                                            <form key={index}>
                                                <div className="scrollable">
                                                <div>
                                                    <div className="col-lg-4">
                                                        <label>Hubspot Company Id</label>
                                                        <input type="text" disabled className="form-control" name="companyId" defaultValue={item.companyId} />
                                                    </div>
                                                    <div className="col-lg-4 gap">
                                                        <label>Contact Name</label>
                                                        <input type="text" disabled className="form-control" name="contactName" defaultValue={item.contactName} />
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <label>Commission</label>
                                                        <input type="text" className="form-control" name="wholesalerCommission" defaultValue={item.defaultCommission} />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="col-lg-3">
                                                        <label>Commission Rules</label>
                                                        <div className="same">
                                                            <input type="radio" disabled dataindex={index} name="rules" value="yes" onChange={this.showCommission} className={item.isRuleBased ? 'form-control checked yes radiobox' : 'form-control radiobox'} />
                                                            <span>Yes</span>
                                                        </div>
                                                        <div className="same">
                                                            <input type="radio" disabled dataindex={index} name="rules" value="no" onChange={this.hideCommission} className={item.isRuleBased ? 'form-control radiobox' : 'form-control checked no radiobox'} />
                                                            <span>No</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <label>Enable GlicRx</label>
                                                        <div className="add-glic">
                                                            <div className="create-dash-glic">
                                                                {
                                                                    item.isGlicRx ?
                                                                        <input type="checkbox" id="enableGlic" name="enableGlic" checked="checked" readOnly className="form-control checkbox" /> :
                                                                        <input type="checkbox" id="enableGlic" name="enableGlic" disabled={true} readOnly className="form-control checkbox" />
                                                                }
                                                                <label for="enableGlic">&nbsp;</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <label>Custom Group Prefix?</label>
                                                        <div className="same">
                                                            {
                                                                item.isCustomGroup ? <input type="radio" disabled name="customGroup" value="yes" className={item.isCustomGroup ? 'form-control checked radiobox' : 'form-control radiobox'} /> :
                                                                    <input type="radio" name="customGroup" disabled value="yes" className={item.isCustomGroup ? 'form-control checked radiobox' : 'form-control radiobox'} onChange={this.handleChangeChk.bind(this)} />
                                                            }
                                                            <span>Yes</span>
                                                        </div>
                                                        <div className="same">
                                                            {
                                                                item.isCustomGroup ? <input type="radio" disabled name="customGroup" value="no" className={item.isCustomGroup ? 'form-control radiobox' : 'form-control checked radiobox'} /> :
                                                                    <input type="radio" name="customGroup" disabled value="no" className={item.isCustomGroup ? 'form-control radiobox' : 'form-control checked radiobox'} onChange={this.handleChangeUnChk.bind(this)} />
                                                            }
                                                            <span>No</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <label>Email</label>
                                                        <input type="email" disabled className="form-control" name="email" defaultValue={item.emailId} />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="col-lg-3">
                                                        <label>Dynamic User Commission</label>
                                                        <div className="same">
                                                            <input type="radio" dataindex={index} name="dynamicCommission" value="yes" onChange={this.showDynamicCommission} className={item.isDynamic ? 'form-control checked yes radiobox' : 'form-control radiobox'} />
                                                            <span>Yes</span>
                                                        </div>
                                                        <div className="same">
                                                            <input type="radio" dataindex={index} name="dynamicCommission" value="no" onChange={this.hideDynamicCommission} className={item.isDynamic ? 'form-control radiobox' : 'form-control checked no radiobox'} />
                                                            <span>No</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <label>Enable TripRx</label>
                                                        <div className="add-glic">
                                                            <div className="create-dash-glic">
                                                                <input type="checkbox" id="triprx" name="triprx" className={item.isTripRx ? "form-control checked checkbox" : "form-control checkbox"} />
                                                                <label for="triprx">&nbsp;</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <label>Show Prescriber Data</label>
                                                        <div className="same">
                                                            {
                                                                item.isPrescriberData ? <input type="radio" name="prescriberData" value="yes" className={item.isPrescriberData ? 'form-control checked radiobox' : 'form-control radiobox'} /> :
                                                                    <input type="radio" name="prescriberData" value="yes" className={item.isPrescriberData ? 'form-control checked radiobox' : 'form-control radiobox'} onChange={this.handlePrescribeData.bind(this)} />
                                                            }
                                                            <span>Yes</span>
                                                        </div>
                                                        <div className="same">
                                                            {
                                                                item.isPrescriberData ? <input type="radio" name="prescriberData" value="no" className={item.isPrescriberData ? 'form-control radiobox' : 'form-control checked radiobox'} /> :
                                                                    <input type="radio" name="prescriberData" value="no" className={item.isPrescriberData ? 'form-control radiobox' : 'form-control checked radiobox'} onChange={this.handlePrescribeData.bind(this)} />
                                                            }
                                                            <span>No</span>
                                                        </div>
                                                    </div>
                                                    {/*<div className="col-lg-3">
                                                        <label>Add Override</label>
                                                        <div className="same">
                                                            <input type="radio" name="overrideData" value="yes" className={this.state.IsCommissionPrescribeData ? 'form-control checked radiobox' : 'form-control radiobox'} onChange={this.handleCommissionPrescribeData.bind(this)} />
                                                            <span>Yes</span>
                                                        </div>
                                                        <div className="same">
                                                            <input type="radio" name="overrideData" value="no" className={this.state.IsCommissionPrescribeData ? 'form-control radiobox' : 'form-control checked radiobox'} onChange={this.handleCommissionPrescribeData.bind(this)} />
                                                            <span>No</span>
                                                        </div>
                                                    </div>*/}
                                                </div>
                                                <div className="override-section milestone">
                                                    {
                                                        item.isRuleBased ?
                                                            <div>
                                                                {
                                                                    this.state.commissionMilestone != null && this.state.commissionMilestone.length > 0 ?
                                                                        <div className="right">
                                                                            <h2>Commission Milestones</h2>
                                                                            <a href="javascript:void('0')" className="add-new" onClick={this.addMilestone}>Add Milestone</a>
                                                                            <table id="milestoneTable">
                                                                                <thead>
                                                                                    <tr className="header Sub">
                                                                                        <th className="first-one">Milestone</th>
                                                                                        <th className="second-one">From</th>
                                                                                        <th className="third-one">To</th>
                                                                                        <th className="fourth-one">Commission</th>
                                                                                        <th className="fifth-one">Actions</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                    <tbody style={{overflow: 'unset', height: 'auto'} }>
                                                                                    {
                                                                                        this.state.commissionMilestone.map((e1, innerIndex) => {
                                                                                            return (
                                                                                                e1.isineditedmode ?
                                                                                                    <tr className="milestoneData" key={innerIndex}>
                                                                                                        <td className="first-one">
                                                                                                            <div className="formgroup">
                                                                                                                <label>{innerIndex + 1}</label>
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        <td className="second-one">
                                                                                                            <div className="formgroup">
                                                                                                                <input type="text" defaultValue={e1.from} className="form-control" name="from" />
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        <td className="third-one">
                                                                                                            <div className="formgroup">
                                                                                                                <input type="text" defaultValue={e1.to} className="form-control" name="to" />
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        <td className="fourth-one">
                                                                                                            <div className="formgroup">
                                                                                                                <input type="text" defaultValue={e1.commission} className="form-control" name="mComm" />
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        <td className="fifth-one">
                                                                                                            <input type="button" onClick={this.saveData} dataindex={innerIndex} className="btn" value="Save" />
                                                                                                            <input type="button" dataindex={innerIndex} onClick={this.cancelList} className="btn cancel" value="Cancel" />
                                                                                                        </td>
                                                                                                    </tr> :
                                                                                                    <tr className="milestoneData editable" key={innerIndex}>
                                                                                                        <td className="first-one">
                                                                                                            <div className="formgroup">
                                                                                                                <label>{innerIndex + 1}</label>
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        <td className="second-one">
                                                                                                            <div className="formgroup">
                                                                                                                <label>{e1.from}</label>
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        <td className="third-one">
                                                                                                            <div className="formgroup">
                                                                                                                <label>{e1.to}</label>
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        <td className="fourth-one">
                                                                                                            <div className="formgroup">
                                                                                                                <label>{e1.commission}</label>
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        <td className="fifth-one">
                                                                                                            <img dataindex={innerIndex} onClick={this.handleEdit} src={EditIcon} className="editIcon" alt="editIcon" />
                                                                                                            <img src={DeleteIcon} dataindex={innerIndex} onClick={this.deleteMilestone} className="deleteIcon" alt="deleteIcon" />
                                                                                                        </td>
                                                                                                    </tr>
                                                                                            )
                                                                                        })
                                                                                    }

                                                                                </tbody>
                                                                            </table>
                                                                        </div> :
                                                                        <div className="right">
                                                                            <div className="list-section">
                                                                                <h2>Commission Milestones</h2>
                                                                                <span className="no-override">No milestones added yet</span>
                                                                                <a href="javascript:void('0')" className="add-new some" onClick={this.addMilestone}>Add Milestone</a>
                                                                            </div>
                                                                        </div>
                                                                }
                                                            </div> : null

                                                    }
                                                    </div>
                                                </div>
                                                <div className="button-group">
                                                    {
                                                        //this.state.btnLoader ? <div className="theme-loader btn-profile-loader c-milestone"></div> : null
                                                    }
                                                    <button type="button" datacompanyid={item.companyId} onClick={this.handleSaveSubmit} className={this.state.btnLoader ? 'btn save animated-btn gradient-btn' : 'btn save gradient-btn'}>Save</button>
                                                    <button type="button" onClick={this.handleCancel} className="btn cancel gradient-btn">Cancel</button>
                                                    {item.isDynamic ?
                                                        <button datacompanyid={item.companyId} type="button" className="add-new advance btn-outline" onClick={this.dynamicCommission}>{this.state.isEditable ? 'Edit/View Tier Commission' : 'Add Tier Commission'}</button>
                                                        : null
                                                    }
                                                    <button className="add-new advance btn-outline" type="button" onClick={this.handleBonus}>Bonus Program</button>
                                                    <button data-glic={item.isGlicRx} type="button" className="add-new advance btn-outline" onClick={this.advanceSetting}>Advance settings</button>
                                                    <button className="add-new btn-outline" type="button" onClick={this.addOverrides}>Overrides</button>
                                                    <button className="add-new btn-outline" type="button" onClick={this.handleCommissionPrescribeData.bind(this, true)}>Chain List</button>

                                                    {error &&
                                                        <div className={'alert alert-danger left-gap'}>{error}</div>
                                                    }
                                                </div>
                                                {/*<div className="button-section tier">
                                                    {
                                                        this.state.btnLoader ? <div className="theme-loader btn-profile-loader c-milestone"></div> : null
                                                    }
                                                    <input type="button" datacompanyid={item.companyId} onClick={this.handleSaveSubmit} className={this.state.btnLoader ? 'btn save animated-btn' : 'btn save'} value="Save" />
                                                    <input type="button" onClick={this.handleCancel} className="btn cancel" value="Cancel" />
                                                    <a href="javascript:void('0')" className="add-new" onClick={this.addOverrides}>Overrides</a>
                                                    <a href="javascript:void('0')" className="add-new" onClick={this.handleCommissionPrescribeData.bind(this)}>Chain List</a>
                                                    <a href="javascript:void('0')" data-glic={item.isGlicRx} className="add-new advance" onClick={this.advanceSetting}>Advance settings</a>
                                                    <a href="javascript:void('0')" className="add-new advance" onClick={this.handleBonus}>Bonus Program</a>
                                                    {item.isDynamic ?
                                                        <a href="javascript:void('0')" datacompanyid={item.companyId} className="add-new advance" onClick={this.dynamicCommission}>{this.state.isEditable ? 'Edit/View Tier Commission' : 'Add Tier Commission'}</a>
                                                        : null
                                                    }
                                                    {error &&
                                                        <div className={'alert alert-danger left-gap'}>{error}</div>
                                                    }
                                                </div>*/}
                                            </form>
                                        )
                                    })
                                }
                            </div>
                            : null
                    }
                </div>
            </div>
        )
    }
}

export default ManageProfile;